export default __webpack_public_path__ + "static/media/DAI-icon.de194628.png";